import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Ticket from "../components/Ticket";
import { getTicketPrice, getUserInfo, getUserMegaTickets } from "../web3";
import RightArrow from "../assets/icons/right-arrow-1.svg";
import { Spin } from "antd";
import { ApiClient } from "../utils/ApiClient";


function Profile(props: any) {
    const [isActive, setIsActive] = useState(false);
    const [jackpotActiveTickets, setJackpotActiveTickets] = useState<any>([]);
    const [megaJackpotActiveTickets, setMegaJackpotActiveTickets] = useState<any>([]);
    const [jackpotWinningTickets, setJackpotWinningTickets] = useState<any>([]);
    const [megaJackpotWinningTickets, setMegaJackpotWinningTickets] = useState<any>([]);
    const [activeTickets, setActiveTickets] = useState<any>([]);
    const [inActiveTickets, setInActiveTickets] = useState<any>([]);
    const [ticketPrice, setTicketPrice] = useState();
    const [loading, setLoading] = useState<any>(false);
    const { t } = useTranslation();

    const apiClient = new ApiClient("https://cryptolottery777.com/public/tickets");
    const apiClientMega = new ApiClient("https://cryptolottery777.com/public/megajackpots");
    const apiClientJackpotWinnings = new ApiClient("https://cryptolottery777.com/public/winningtickets");
    const apiClientMegaJackpotWinnings = new ApiClient("https://cryptolottery777.com/public/winningmegajackpots/data");


    useEffect(() => {        
        const fetchData = async () => {
            try {
                setLoading(true);

                if (props.address) {
                    const [jackpotRes, winningsRes, megaRes] = await Promise.all([
                        apiClient.post({ walletAddress: props.address }),
                        apiClientJackpotWinnings.post({ walletAddress: props.address }),
                        apiClientMega.post({ walletAddress: props.address })
                    ]);


                    setJackpotActiveTickets(jackpotRes);
                    setActiveTickets(jackpotRes);


                    setJackpotWinningTickets(winningsRes);
                    setInActiveTickets(winningsRes);


                    setMegaJackpotActiveTickets(megaRes);

                    // console.log("megaWinningRes", megaWinningRes);
                    // setMegaJackpotWinningTickets(megaWinningRes);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [props.address]);


    // useEffect(() => {
    //     let fetchMegaWinningsData = {
    //         tickets: 5,
    //         ticketPrice: 20,
    //         cycle: 1,
    //         winnings: 700,
    //     }
    //
    //     apiClientMegaJackpotWinnings.post(fetchMegaWinningsData).then(res => {
    //         console.log("postMegaWin", res)
    //     });
    // },[props?.address])

    const handleClickJackpot = () => {
        setLoading(true)
        setActiveTickets(jackpotActiveTickets);
        setInActiveTickets(jackpotWinningTickets);
        setIsActive(false)
        setTimeout(() => {
            setLoading(false)
        }, 100)
    }

    const handleClickMegaJackpot = () => {
        setLoading(true)

        setActiveTickets(megaJackpotActiveTickets);
        setInActiveTickets(megaJackpotWinningTickets);
        setIsActive(true)
        setTimeout(() => {
            setLoading(false)
        }, 100)
    }

    return (
        <>
            {loading ? <Spin fullscreen={true} size="large" /> :
                <div className="profile">
                    <div className="route-admin-panel"
                        onClick={() => window.open("https://web-adminpanel.netlify.app", "_blank")}>
                        <div className="route-admin-panel_header">
                            <div className="route-admin-panel_header__left">
                                {t('Панель управления')}
                            </div>
                            <img
                                src={RightArrow}
                                alt="icon"
                                className="route-admin-panel_header__right"
                            />
                        </div>
                        <div className="route-admin-panel_content">
                            {t('Отслеживайте свою статистику на личной панели управления.')}
                        </div>
                    </div>
                    <div className="profile_header">
                        {t('Мои билеты')}
                    </div>
                    <div className="profile_switch-btn-group">
                        <div
                            className={isActive ? "profile_switch-btn-group__btn" : "profile_switch-btn-group__btn is-active-btn"}
                            onClick={handleClickJackpot}>
                            <span
                                className={isActive ? "profile_switch-btn-group__btn___content" : "profile_switch-btn-group__btn___content is-active-btn"}>
                                {t('Джекпот')} ({jackpotActiveTickets.length})
                            </span>
                        </div>
                        <div
                            className={!isActive ? "profile_switch-btn-group__btn" : "profile_switch-btn-group__btn is-active-btn"}
                            onClick={handleClickMegaJackpot}>
                            <span
                                className={!isActive ? "profile_switch-btn-group__btn___content" : "profile_switch-btn-group__btn___content is-active-btn"}>
                                {t('Мега Джекпот')} ({megaJackpotActiveTickets.length})
                            </span>
                        </div>
                    </div>

                    <div className="active-tickets">
                        <div className="active-tickets_header">
                            {activeTickets.length ? t('Активные билеты') : ""}
                        </div>
                        {activeTickets?.map((ticket: any, index: number) => {
                            return (
                                <Ticket
                                    key={index}
                                    ticket={ticket}
                                    is_active={true}
                                />
                            )
                        })}
                        <div className="active-tickets_header">
                            {inActiveTickets.length ? t('Выигрышные билеты') : ""}
                        </div>
                        {inActiveTickets?.map((ticket: any, index: number) => {
                            return (
                                <Ticket
                                    key={index}
                                    ticket={ticket}
                                />
                            )
                        })}
                    </div>
                </div>}
        </>
    )
}

export default Profile
